/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

export function useModalState(
  isSubmitting:   boolean,
  hasError:       boolean,
): [boolean, (show: boolean) => void] {

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!isSubmitting && !hasError) {
      setShowModal(false);
    }
  }, [isSubmitting]);

  return [
    showModal,
    setShowModal
  ]
}
